import React, { useState } from 'react';
import {
  MessageSquare, X, Send, ArrowRight
} from 'lucide-react';
import Whasappicon from '../../../../Assets/InforPage/whatsappIcon.png'

const OdooLandingPage = ({contact}) => {

  const [showWhatsAppDialog, setShowWhatsAppDialog] = useState(false);
  const [whatsAppMessage, setWhatsAppMessage] = useState('');
  const handleWhatsAppOpen = () => {
    setShowWhatsAppDialog(true);
  };
    
  const handledowntocontact = () => {
    contact.current.scrollIntoView({ behavior: 'smooth' });
  };

  const handleWhatsAppSend = () => {
    const message = whatsAppMessage || 'Hello! I am interested in your Odoo implementation services.';
    const phoneNumber = '9154673864'; 
    const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
    window.open(whatsappUrl, '_blank');
    setShowWhatsAppDialog(false);
    setWhatsAppMessage('');
  };

  return (
    <div className="relative w-full overflow-x-hidden" style={{ backgroundColor: '#FFF7FD' }}>
      {/* WhatsApp Dialog */}
      {showWhatsAppDialog && (
        <div className="fixed inset-0 backdrop-blur-sm flex items-center justify-center z-50 p-4" style={{ backgroundColor: 'rgba(0, 0, 0, 0.6)' }}>
          <div className="bg-white rounded-2xl md:rounded-3xl shadow-2xl w-full max-w-xs sm:max-w-sm md:max-w-md p-4 sm:p-6 md:p-8 transform animate-scale-in" style={{ border: '1px solid #F3F4F6' }}>
            <div className="flex items-center justify-between mb-4 sm:mb-6 md:mb-8">
              <div className="flex items-center space-x-2 sm:space-x-3 md:space-x-4">
                <div className="w-10 h-10 sm:w-12 sm:h-12 md:w-14 md:h-14 rounded-xl sm:rounded-2xl flex items-center justify-center shadow-lg" style={{ background: 'linear-gradient(135deg, #22C55E 0%, #16A34A 100%)' }}>
                  <MessageSquare className="w-5 h-5 sm:w-6 sm:h-6 md:w-7 md:h-7 text-white" />
                </div>
                <div>
                  <h3 className="text-lg sm:text-xl font-bold" style={{ color: '#1F2937' }}>WhatsApp Contact</h3>
                  <p className="text-xs sm:text-sm" style={{ color: '#6B7280' }}>Send us a message</p>
                </div>
              </div>
              <button
                onClick={() => setShowWhatsAppDialog(false)}
                className="w-8 h-8 sm:w-9 sm:h-9 md:w-10 md:h-10 rounded-full flex items-center justify-center transition-colors"
                style={{ backgroundColor: '#F3F4F6' }}
                onMouseEnter={(e) => e.target.style.backgroundColor = '#E5E7EB'}
                onMouseLeave={(e) => e.target.style.backgroundColor = '#F3F4F6'}
              >
                <X className="w-4 h-4 sm:w-5 sm:h-5" style={{ color: '#6B7280' }} />
              </button>
            </div>
            
            <div className="space-y-4 sm:space-y-6">
              <div>
                <label className="block text-sm font-semibold mb-2 sm:mb-3" style={{ color: '#374151' }}>
                  Your Message
                </label>
                <textarea
                  value={whatsAppMessage}
                  onChange={(e) => setWhatsAppMessage(e.target.value)}
                  placeholder="Hello! I am interested in your Odoo implementation services."
                  className="w-full px-3 sm:px-4 py-3 sm:py-4 rounded-lg sm:rounded-xl resize-none transition-all duration-200 text-sm sm:text-base"
                  style={{ 
                    border: '1px solid #E5E7EB',
                    focusBorderColor: '#10B981'
                  }}
                  onFocus={(e) => {
                    e.target.style.borderColor = '#10B981';
                    e.target.style.boxShadow = '0 0 0 3px rgba(16, 185, 129, 0.1)';
                  }}
                  onBlur={(e) => {
                    e.target.style.borderColor = '#E5E7EB';
                    e.target.style.boxShadow = 'none';
                  }}
                  rows="4"
                />
              </div>
              
              <div className="flex flex-col sm:flex-row space-y-3 sm:space-y-0 sm:space-x-4">
                <button
                  onClick={() => setShowWhatsAppDialog(false)}
                  className="px-4 sm:px-6 py-2.5 sm:py-3 rounded-lg sm:rounded-xl font-medium transition-colors text-sm sm:text-base"
                  style={{ 
                    border: '1px solid #E5E7EB',
                    color: '#6B7280',
                    backgroundColor: 'transparent'
                  }}
                  onMouseEnter={(e) => e.target.style.backgroundColor = '#F9FAFB'}
                  onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}
                >
                  Cancel
                </button>
                <button
                  onClick={handleWhatsAppSend}
                  className="px-4 sm:px-6 py-2.5 sm:py-3 text-white rounded-lg sm:rounded-xl font-medium transition-all duration-200 flex items-center justify-center space-x-2 shadow-lg text-sm sm:text-base"
                  style={{ background: 'linear-gradient(90deg, #10B981 0%, #059669 100%)' }}
                  onMouseEnter={(e) => e.target.style.background = 'linear-gradient(90deg, #059669 0%, #047857 100%)'}
                  onMouseLeave={(e) => e.target.style.background = 'linear-gradient(90deg, #10B981 0%, #059669 100%)'}
                >
                  <Send className="w-3.5 h-3.5 sm:w-4 sm:h-4" />
                  <span>Send</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      <section
        className="relative isolate overflow-hidden"
        aria-labelledby="odoo-intro-heading"
      >
        <div
          className="pointer-events-none absolute inset-0 -z-10 hidden bg-cover bg-right bg-no-repeat lg:block"
          style={{ backgroundImage: 'url(https://ik.imagekit.io/7wqj9br0b/PTKCS/odoo_bg.webp)' }}
          aria-hidden="true"
        />
        <div className="mx-auto flex max-w-[1920px] items-center px-5 pt-12 sm:px-8 sm:pt-16 lg:min-h-[max(440px,38.23vw)] lg:px-12 lg:py-10 xl:px-20 2xl:px-28">
          <div className="w-full lg:w-[47%] lg:max-w-[720px]">
            <h1 id="odoo-intro-heading" className="m-0 font-bold leading-tight tracking-tight">
              <span className="mt-2 block text-2xl font-bold sm:text-3xl xl:text-4xl" style={{ color: '#17131A' }}>
                KCS Tech Odoo <br/> Implementation Services
              </span>
            </h1>
            <p
              className="mb-0 mt-5 max-w-xl text-left text-sm font-medium leading-relaxed sm:text-base lg:text-sm xl:text-base 2xl:text-lg"
              style={{ color: '#342D38', wordBreak: 'normal', overflowWrap: 'normal', hyphens: 'none' }}
            >
              KCS Tech is trusted partner for your Odoo consulting services, and we specialized in Odoo Implementation services to grow your business very efficiently. We have customized ERP solutions for managing and integrating various business functions with efficiency to achieve the strategic goals.
            </p>
            <button
              type="button"
              onClick={handledowntocontact}
              className="mt-7 inline-flex items-center justify-center gap-3 rounded-xl px-6 py-3.5 text-sm font-semibold shadow-sm hover:shadow-md focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 motion-safe:transition-transform motion-safe:hover:-translate-y-0.5 sm:text-base"
              style={{ backgroundColor: '#714B67', color: '#FFFFFF', outlineColor: '#714B67' }}
            >
              Get Started Today
              <ArrowRight className="h-4 w-4" aria-hidden="true" />
            </button>
          </div>
        </div>
        <div
          className="mt-8 aspect-[960/734] w-full bg-cover bg-right bg-no-repeat sm:aspect-[3/2] lg:hidden"
          style={{ backgroundImage: 'url(https://ik.imagekit.io/7wqj9br0b/PTKCS/odoo_bg.webp)' }}
          aria-hidden="true"
        />
      </section>
      {/* Enhanced WhatsApp Button */}
      <div className="fixed bottom-4 sm:bottom-6 md:bottom-8 left-4 sm:left-6 md:left-8 z-50">
        <button
          onClick={handleWhatsAppOpen}
          className="relative w-12 h-12 sm:w-14 sm:h-14 md:w-16 md:h-16 bg-gradient-to-br from-green-400 to-green-600 text-white rounded-xl sm:rounded-2xl shadow-xl hover:shadow-2xl transform hover:scale-105 md:hover:scale-110 transition-all duration-300 group border-2 sm:border-3 md:border-4 border-white"
        >
          <img src={Whasappicon} alt="Contact KCS Tech for Odoo Services" className="w-6 h-6 sm:w-7 sm:h-7 md:w-8 md:h-8 mx-auto" />
          <div className="absolute -top-1 -right-1 sm:-top-2 sm:-right-2 w-4 h-4 sm:w-5 sm:h-5 md:w-6 md:h-6 bg-gradient-to-r from-red-400 to-red-600 rounded-full flex items-center justify-center shadow-lg">
            <span className="text-[10px] sm:text-xs text-white font-bold">1</span>
          </div>
          <div className="absolute inset-0 rounded-xl sm:rounded-2xl bg-green-400 opacity-0 group-hover:opacity-30 transition-opacity duration-300 animate-ping"></div>
        </button>
      </div>

      <style jsx>{`
        @keyframes fade-in-up {
          from {
            opacity: 0;
            transform: translateY(40px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        @keyframes fade-in-right {
          from {
            opacity: 0;
            transform: translateX(40px);
          }
          to {
            opacity: 1;
            transform: translateX(0);
          }
        }

        @keyframes rotate-slow {
          from {
            transform: rotate(0deg);
          }
          to {
            transform: rotate(360deg);
          }
        }

        @keyframes counter-rotate {
          from {
            transform: rotate(0deg);
          }
          to {
            transform: rotate(-360deg);
          }
        }

        @keyframes float {
          0%, 100% {
            transform: translateY(0px) translateX(0px) scale(1);
          }
          25% {
            transform: translateY(-10px) translateX(5px) scale(1.05);
          }
          50% {
            transform: translateY(-5px) translateX(-5px) scale(0.95);
          }
          75% {
            transform: translateY(-12px) translateX(3px) scale(1.03);
          }
        }

        @keyframes scale-in {
          from {
            opacity: 0;
            transform: scale(0.9);
          }
          to {
            opacity: 1;
            transform: scale(1);
          }
        }

        .animate-fade-in-up {
          animation: fade-in-up 0.8s ease-out forwards;
        }

        .animate-fade-in-right {
          animation: fade-in-right 0.8s ease-out forwards;
        }

        .animate-rotate-slow {
          animation: rotate-slow 30s linear infinite;
          transform-origin: center center;
        }

        .animate-counter-rotate {
          animation: counter-rotate 30s linear infinite;
          transform-origin: center center;
        }

        .animate-float {
          animation: float ease-in-out infinite;
        }

        .animate-scale-in {
          animation: scale-in 0.3s ease-out forwards;
        }

        /* Mobile-specific styles */
        @media (max-width: 640px) {
          .animate-fade-in-up,
          .animate-fade-in-right {
            animation-duration: 0.6s;
          }
          
          .animate-rotate-slow,
          .animate-counter-rotate {
            animation-duration: 40s;
          }
        }

        /* Enhanced focus styles */
        input:focus, textarea:focus {
          outline: none;
          box-shadow: 0 0 0 3px rgba(34, 197, 94, 0.1);
        }

        /* Smooth scrolling */
        html {
          scroll-behavior: smooth;
        }

        /* Custom scrollbar */
        ::-webkit-scrollbar {
          width: 6px;
        }

        ::-webkit-scrollbar-track {
          background: #f1f5f9;
        }

        ::-webkit-scrollbar-thumb {
          background: linear-gradient(135deg, #6366F1, #8B5CF6);
          border-radius: 3px;
        }

        ::-webkit-scrollbar-thumb:hover {
          background: linear-gradient(135deg, #4F46E5, #7C3AED);
        }

        /* For touch devices */
        @media (hover: none) and (pointer: coarse) {
          .hover\:scale-110:hover {
            transform: scale(1.05);
          }
          
          .hover\:-translate-y-2:hover {
            transform: translateY(-1px);
          }
          
          button, div[role="button"] {
            cursor: pointer;
            -webkit-tap-highlight-color: transparent;
          }
        }

        /* Prevent text selection on interactive elements */
        button, [role="button"] {
          user-select: none;
        }
      `}</style>
    </div>
  );
};

export default OdooLandingPage;